import React from 'react';
import { Icon } from './Icon.js';
export const IconCompactDiskFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9,1C4.589,1,1,4.589,1,9s3.589,8,8,8,8-3.589,8-8S13.411,1,9,1Zm0,10.5c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5,2.5,1.119,2.5,2.5-1.119,2.5-2.5,2.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCompactDiskFill18.js.map